export const paymentAction= (data) => { 
    return {
       type: data.type,
       data:data.data
    }
 }